import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { setAlert } from '../../actions/alert';
import { crearCita, buscarAsesores, buscarHorariosCita } from '../../actions/nutricional';
import { buscarJovenes } from '../../actions/jovenes';

const NuevaCita = ({ cita, reestablecerCita }) => {

    const dispatch =  useDispatch();

    const jovenes = useSelector(state => state.jovenes);
    const { listado_asesores, listado_horarios_cita } = useSelector(state => state.nutricional);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [citaData, setCitaData] = useState({
        id_joven: null,
        id_asesor: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        nacimiento: null,
        curp: '',
        email: '', 
        fecha: null,
        hora_inicio: null,
        hora_fin: null,
        observaciones: null
    });

    const [jovenData, setJovenData] = useState(null);
    const [jovenesFilter, setJovenesFilter] = useState([]);

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);

    const [horarioData, setHorarioData] = useState(null);
    const [horariosFilter, setHorariosFilter] = useState([]);

    /* Crear cita */
    const handleAbrir = () => {
        dispatch(buscarJovenes({
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            celular: null,
            email: null,
            curp: null, 
            nivel: null,
            institucion: null
        }));

        dispatch(buscarAsesores());
    }

    const handleSelectJoven = (option) => {
        setJovenData(option);

        setCitaData({
            ...citaData,
            id_joven: option != null ? option.value : null
        });
    }

    const handleBirthdayPicker = (value) => {
        setCitaData({
            ...citaData,
            nacimiento: value
        });
    }

    const handleInputChange = ({ target }) => {
        setCitaData({
            ...citaData,
            [target.name]: target.value
        });
    }

    const handleSelectAsesor = (option) => {
        setAsesorData(option);

        setCitaData({
            ...citaData,
            id_asesor: option != null ? option.value : null, 
            hora_inicio: null,
            hora_fin: null
        });

        setHorarioData(null);
        
        if(citaData.fecha){
            dispatch(buscarHorariosCita(null, option?.value || null, citaData.fecha));
        }else{
            setHorariosFilter([]);
        }
    }

    const handleDatePicker = (name, value) => {
        setCitaData({
            ...citaData,
            [name]: value, 
            hora_inicio: null,
            hora_fin: null
        });

        setHorarioData(null);

        if(value){
            dispatch(buscarHorariosCita(null, asesorData?.value || null, value));
        }else{
            setHorariosFilter([]);
        }
    }

    const handleSelectHorario = (option) => {
        setHorarioData(option);

        setCitaData({
            ...citaData,
            hora_inicio: option != null ? option.hora_inicio : null,
            hora_fin: option != null ? option.hora_fin : null
        });
    }
    
    const handleProcesar = async () => {
        if(citaData.id_joven || (citaData.nombre && citaData.apellido_paterno && citaData.nacimiento && (citaData.curp || citaData.email))){
            if(citaData.id_asesor){
                if(citaData.fecha){
                    if(citaData.hora_inicio <= citaData.hora_fin && (citaData.hora_inicio && citaData.hora_fin)){
                        await setStatusProcesar(true);
                        await dispatch(crearCita(citaData));
                        await handleCerrar();
                        await setStatusProcesar(false);
                    }else{
                        await dispatch(setAlert('La hora de inicio debe ser menor o igual a la de finalización', 'danger'));
                    }
                }else{
                    await dispatch(setAlert('La fecha de la cita es requerida', 'danger'));
                }
            }else{
                await dispatch(setAlert('Ingresa el asesor al que se le reservara', 'danger'));
            }
        }else{
            await dispatch(setAlert('Ingresa el joven al que se le reservara', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setCitaData({
                id_joven: null,
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                nacimiento: null,
                curp: '',
                email: '', 
                fecha: null,
                hora_inicio: null,
                hora_fin: null,
                observaciones: null
            });

            setJovenData(null);
            setAsesorData(null);
            setHorarioData(null);
            setNuevoModal(false);
            reestablecerCita(null);

            setHorariosFilter([]);
        }
    }

    useEffect(() => {
        if(cita){
            setNuevoModal(true);

            setCitaData({
                ...citaData
            });
        }        
    }, [cita]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < jovenes.listado?.length; i++) {
            options.push({ value: jovenes.listado[i]._id, label: [jovenes.listado[i].nombre, jovenes.listado[i].apellido_paterno, jovenes.listado[i].apellido_materno].join(' ') });
        }

        setJovenesFilter(options);
    }, [jovenes]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_asesores.length; i++) {
            options.push({ value: listado_asesores[i]._id, label: [listado_asesores[i].nombre, listado_asesores[i].apellido_paterno, listado_asesores[i].apellido_materno].join(' ') });
        }

        setAsesoresFilter(options);
    }, [listado_asesores]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_horarios_cita.length; i++) {
            options.push({ value: i, label: [listado_horarios_cita[i].hora_inicio, listado_horarios_cita[i].hora_fin].join(' - '), hora_inicio: listado_horarios_cita[i].hora_inicio, hora_fin: listado_horarios_cita[i].hora_fin });
        }

        setHorariosFilter(options);
    }, [listado_horarios_cita]);

    return (
        <Modal show={nuevoModal} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar cita</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_joven"
                                name="id_joven"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar joven"
                                isClearable
                                options={jovenesFilter}
                                value={jovenData}
                                onChange={(value) => handleSelectJoven(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 mb-3">
                        <hr></hr>
                        <p>O bien, crea un registro nuevo desde cero. La contraseña temporal de esta nueva cuenta será "iaju".</p>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={citaData.nombre} disabled={jovenData ? true : false} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={citaData.apellido_paterno} disabled={jovenData ? true : false} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="apellido_paterno">Apellido paterno</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={citaData.apellido_materno} disabled={jovenData ? true : false} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="apellido_materno">Apellido materno</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="nacimiento"
                                    name="nacimiento"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    locale="es-ES"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ citaData.nacimiento != null ? new Date(citaData.nacimiento) : '' }
                                    disabled={jovenData ? true : false}
                                    onChange={ date => handleBirthdayPicker(date) }
                                />
                                <label className="label-datepicker" htmlFor="nacimiento">Fecha de nacimiento</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="CURP" id="curp" name="curp" value={citaData.curp} disabled={jovenData ? true : false} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="curp">CURP</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Correo" id="email" name="email" value={citaData.email} disabled={jovenData ? true : false} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="email">Correo</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mb-3">
                        <hr></hr>
                    </div>

                    <div className="col-md-5 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_asesor"
                                name="id_asesor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar asesor"
                                isClearable
                                options={asesoresFilter}
                                value={asesorData}
                                onChange={(value) => handleSelectAsesor(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha"
                                    name="fecha"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    minDate={new Date()}
                                    selected={ citaData.fecha != null ? new Date(citaData.fecha) : '' }
                                    onChange={ date => handleDatePicker('fecha', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="horario"
                                name="horario"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar horario"
                                isClearable
                                options={horariosFilter}
                                value={horarioData}
                                onChange={(value) => handleSelectHorario(value)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={citaData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                                <label htmlFor="observaciones">Observaciones</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevaCita;